// Actions
export const CATEGORY_FETCH  = '[Category] Fetch'

// Mutations
export const CATEGORY_META   = '[Category] meta'
export const CATEGORY_OBTAIN = '[Category] obtain'
export const CATEGORY_CLEAR  = '[Category] clear'
export const CATEGORY_SET_LOADING = '[Category] set loading'
